import GET_ARTICLES from '../class/getArticles';
import GET_INSTAGRAM from '../class/getInstagram'
import Swiper from 'swiper/bundle';
import LazyDisp from "../class/lazydisp";
import SPLASH from '../class/splash';

const [ w, d ] = [window, document];

const domReady = (TPL,splash) => {

  let mainvisual = new Swiper('.mainvisual__slider', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 2000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  });
  mainvisual.autoplay.stop();
  
  splash.then( () => {
    mainvisual.autoplay.start();
  });

  //ticker
  const ticker_block = new GET_ARTICLES('.block-ticker__article[data-plugin="getArticles"]');
  ticker_block.makeItem = (item) => `
    <a href="${item.href}" class="block-ticker__link">
      <div class="date-cate">
        <span class="date">${item.date}</span>
        <span class="cate">【${item.category.name}】</span>
      </div>
      <h4 class="subject"><span>${item.title.str_truncate(24)}</span></h4>
    </a>`;
  ticker_block.render();
  
  //NEWS
  const news_block = new GET_ARTICLES('.block-news__list[data-plugin="getArticles"]');
  news_block.makeItem = (item,content) => `
  <li class="block-${content}-item">
    <a href="/${content}/?mode=detail&amp;article=${item.id}" class="block-${content}-item__link">
      <div class="block-${content}-item__body">
        <div class="date-cate">
          <span class="date">${item.date}</span>
          <span class="cate">【${item.category.name}】</span>
        </div>
        <h4 class="title ${item.is_new? 'is-new':''}">${item.title.str_truncate(24)}</h4>
      </div>
    </a>
  </li>`;
  // news_block.makeItem = (item) => console.log(item);
  news_block.render();

};

const jqInit = () => {
  Promise.all([w.load['loadHtml']]).then(() => {
    // LazyDisp開始
    new LazyDisp('[data-lazydisp]')
    
    // Instagram
    GET_INSTAGRAM()
  });
};


export default function HOME () {
  const splash = new SPLASH;
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail, splash) );
  
  $(() => jqInit());
}